import { CSSProperties } from "vue";
export interface CustomPage {
    id?: string;
    campaignId?: string;
    name: string;
    url?: string;
    layout: Container;
    createdAt?: string;
    updatedAt?: string;
}
export interface Container {
    _id: string;
    type: string;
    campaignId?: string;
    name?: string;
    active: boolean;
    text?: string;
    action: Action;
    actions: Action[];
    styles: CSSProperties;
    attributes: Attributes;
    elements?: Container[];
    containers?: Container[];
}

export enum ActionType {
    NONE = "none",
    API_CALL = "api-call",
    GO_TO_PAGE = "go-to-page",
    GO_TO_URL = "go-to-url",
    DROP_ITEMS = "drop-items",
    CLAIM_ITEM = "claim-item",
    REDEEM_ITEM = "redeem-item",
    REDEEM_URL_ITEM = "redeem-url-item",
    REDEEM_MOMINT_NFT = "redeem-momint-nft",
    OPEN_POPUP = "open-popup",
    CLOSE_POPUP = "close-popup",
    CENTER_MAP = "center-map",
    SIGNUP = "signup",
    SIGNIN_REQUEST_CODE = "signin-request-code",
    SUBMIT_PIN = "submit-pin",
    SHOW_SCANNER = "show-scanner",
    SHOW_FACECARD = "show-facecard",
    SHARE_LINK = "share-link",
    LOG_OUT = "log-out",
    RESEND_PIN = "resend-pin",
    SHARE_REWARD = "share-reward",
    CANCEL_SHARE_REWARD = "cancel-share-reward",
    RESHARE_REWARD = "reshare-reward",
    COPY_TO_CLIPBOARD = "copy-to-clipboard",
    ACTION_POINT_INCREMENT = "action-point-increment",
    ACTION_POINT_DECREMENT = "action-point-decrement",
}

export interface Action {
    index?: number;
    type: ActionType | null;
    value: string | null;
    enableActionPoints?: boolean;
    actionPoints?: number;
}

export interface Attributes {
    id?: string;
    name?: string;
    classes?: string[];
    type?: string;
    text?: string;
    label?: string;
    icon?: string;
    width?: string;
    height?: string;
    placeholder?: string;
    src?: string;
    disabled?: string;
    controls?: string;
    autoplay?: string;
    loop?: string;
    muted?: string;
    checked?: boolean;
}
